import { Component } from '@angular/core'
import { FilterProductsService } from '../../services/filter-products.service'
import { map, shareReplay } from 'rxjs/operators'
import { BaseSiteService, VariantOption } from '@spartacus/core'
import { DataAnalyticsClickSource } from '../../../shared/mb-constants'

@Component({
  selector: 'mb-pdp-variants-list',
  templateUrl: './pdp-variants-list.component.html',
  styleUrls: ['./pdp-variants-list.component.scss']
})
export class PdpVariantsListComponent {

  variantOptions$ = this.filterProductsService.variants$
  hasDynamicColumns$ = this.variantOptions$.pipe(
    map(v => v?.some(vp => vp?.productLine?.productLine?.length) || false)
  )
  dynamicColumnLabels$ = this.variantOptions$.pipe(
    map(pv => this.getDynamicColumnNames(pv)),
    shareReplay(1)
  )
  showWishList$ = this.baseSiteService.get().pipe(
    map(s => s?.supportingAccountCreation && !s.supportingGuestCheckout || false),
    shareReplay(1)
  )
  variantOptionsToDisplay$ = this.filterProductsService.filteredVariants$
  otherSizesOfVariants$ = this.filterProductsService.otherSizesVariants$
  totalVariants$ = this.filterProductsService.totalVariants$

  dataAnalyticsClickSource = DataAnalyticsClickSource.PDP

  constructor (protected filterProductsService: FilterProductsService,
               protected baseSiteService: BaseSiteService) {
  }

  getDynamicColumnNames (variants?: VariantOption[]) {
    const columnLabel = new Set<string>()
    variants?.forEach(variant => variant.productLine?.productLine?.forEach((entry: any) => columnLabel.add(entry?.label)))
    return Array.from(columnLabel)
  }
}
